import { render, staticRenderFns } from "./UserSyncRule.vue?vue&type=template&id=082fcd28&scoped=true"
import script from "./UserSyncRule.vue?vue&type=script&lang=js"
export * from "./UserSyncRule.vue?vue&type=script&lang=js"
import style0 from "./UserSyncRule.vue?vue&type=style&index=0&id=082fcd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082fcd28",
  null
  
)

export default component.exports